import { useEffect, useState } from 'react';
import { logError } from '@edx/frontend-platform/logging';

import { DEFAULT_LANGUAGE, getCourseCatalogue, LOCALE_MAP } from '../utils';

/**
 * Course display names for one learning-path language, keyed by course id —
 * the titles learners see on their course cards.
 */
export function useCourseDisplayNames(language: string | undefined): Map<string, string> {
  const [names, setNames] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    if (!language) {
      return undefined;
    }
    let cancelled = false;
    getCourseCatalogue(LOCALE_MAP[language] || DEFAULT_LANGUAGE)
      .then((res) => {
        if (cancelled) {
          return;
        }
        const map = new Map<string, string>();
        (res?.results ?? []).forEach((course) => {
          const name = course?.data?.content?.display_name?.trim();
          if (course?.data?.id && name) {
            map.set(course.data.id, name);
          }
        });
        setNames(map);
      })
      .catch((error) => logError('Error fetching course display names', error));
    return () => { cancelled = true; };
  }, [language]);

  return names;
}
